import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'

import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { PipelineModel } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { renderPipelineIcon } from '../../utils/PipelineIconUtils'
import * as Styles from './styles'

interface Props {
   pipelineModel: PipelineModel
   onSelect: (pipelineId: string) => void
}

const PipelinePopoverItem = (props: Props): React.ReactElement => {
   const { pipelineModel, onSelect } = props

   const { theme } = useAppTheme()
   const pipelineItemTheme = theme.common.pipelinesPopover.pipelineItem

   const onClickPipeline = () => {
      onSelect(pipelineModel.pipelineId)
   }

   return (
      <button
         className={cn(
            Styles.itemContainerStyles,
            pipelineItemTheme.hoverBgColor
         )}
         onClick={onClickPipeline}
      >
         <div className={Styles.itemLeftIconStyles}>
            {renderPipelineIcon(
               pipelineModel.pipelineId,
               pipelineModel?.pipelineIcon,
               { height: 16, width: 16 }
            )}
         </div>
         <span
            className={cn(Styles.itemTextStyles, pipelineItemTheme.textColor)}
         >
            {pipelineModel.name}
         </span>
      </button>
   )
}

export default observer(PipelinePopoverItem)
